// SD-0037 (cs2460, 23/10) — vale para TODOS os sites. UMA regra para achar a página do menu
// (/menu/<título>) pelo título da URL, usada no SSR (lib/server/site-props.ts resolveMenuFromAllData)
// e no navegador (pages/menu/[name]). Antes o SSR comparava sem acento/caixa/espaço nas pontas e o
// navegador comparava EXATO: link com o título em NFD (acento decomposto — iPhone/WhatsApp), em
// maiúsculas ou com espaço nas pontas abria a página e ~1,5 s depois o cliente mandava para a home.
// Funções PURAS: SSR e cliente dão sempre o mesmo resultado.
import { removerAcentos } from './FunctionsGlobals';

// removerAcentos faz NFKD + tira os combinantes (U+0300–036F): NFC e NFD viram o mesmo texto.
export const normalizarTituloMenu = (titulo: any): string =>
    removerAcentos(String(titulo || '')).toLowerCase().trim();

export const mesmoTituloMenu = (a: any, b: any): boolean =>
    normalizarTituloMenu(a) === normalizarTituloMenu(b);
